import { Routes, Route } from 'react-router-dom'
import { LandingPage } from './components/LandingPage'
import { Login } from './components/Login'
import { Editor } from './components/Editor'
import { Pricing } from './components/Pricing'
import { Terms } from './components/legal/Terms'
import { Privacy } from './components/legal/Privacy'
import { NotFound } from './components/NotFound'
import { RequireAuth } from './components/auth/RequireAuth'

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      {/* Editor / admin — the app lives under /admin to mirror indiepa.ge */}
      <Route
        path="/admin/*"
        element={
          <RequireAuth>
            <Editor />
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
